import { Box, useMediaQuery } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { Area, AreaChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useStore } from '../../store/Store';
import { indNumberFormat } from '../../utils/numberUtils';

const renderGraph = (data, isNotSmallerScreen) => {
    return (
        <>
        <ResponsiveContainer 
            width='100%' aspect={4.0/3.0}
            // width={700} height="80%"
            >
            <AreaChart
            data={data}
            isAnimationActive={false}
            margin={{
                top: 10,
                right: 30,
                left: 0,
                bottom: 10
            }}
            >
            <XAxis dataKey="depositNum" minTickGap={18}/>
            <YAxis tick={false} axisLine={false} />
            <Tooltip wrapperStyle={{ color: '#3e3e3e' }} formatter={(value) => `₹ ${indNumberFormat(value)}`} />
            <Legend 
                wrapperStyle={ isNotSmallerScreen ? { width: "30%", top: 40, left: 20, backgroundColor: '#f5f5f5', border: '1px solid #d5d5d5', borderRadius: 3, lineHeight: '20px', fontSize: '14px' } : {backgroundColor: '#f5f5f5', border: '1px solid #d5d5d5',width: "100%", borderRadius: 3, lineHeight: '20px', fontSize: '14px'}}
            />
            <Area dot={true} name="Maturity Amount"  type="monotone" dataKey="currentValue" stroke="#F0A03F" fill="#F0A03F" />
            <Area dot={true} name="Total Invested" type="monotone" dataKey="totalInvested" stroke="#1479F6" fill="#1479F6" />
            </AreaChart>
        </ResponsiveContainer>
        </>
    )
}

const getGraphData = (data, oneTime) => {
    let graphPoints = data.filter(point => point.isYearEnd);
    var chartPoints = graphPoints.map(({ currentValue, totalInvested }, index) => {
        return {
            depositNum: new Date().getFullYear() + (index + 1),
            currentValue: currentValue,
            totalInvested: totalInvested
        }
    });
    // Insert a base point value
    if(!oneTime) {
    chartPoints.unshift({
        depositNum: new Date().getFullYear(),
        currentValue: 0,
        totalInvested: 0
      });
    }  
    return chartPoints;
}

function Graph() {
    const [state] = useStore();
    const [isNotSmallerScreen] = useMediaQuery("(min-width:600px)");
    const [isLoading, setLoading] = useState(true)
    const { amount, compoundingInterval, period, data, rate, oneTime } = state;

    useEffect(() => {
        setLoading(true);
        let graphPoints = data.filter(point => point.isYearEnd);
        let chartPoints = getGraphData(graphPoints, oneTime);
        chartPoints && chartPoints.length && renderGraph(chartPoints, isNotSmallerScreen);
        setLoading(false);
    }, [amount, compoundingInterval, period, rate, oneTime, data, isNotSmallerScreen]);

    let chartPoints = getGraphData(data, oneTime);

    return (
        <Box m={2} className="graph">
            {isLoading ? <p>Loading...</p> : chartPoints && chartPoints.length ? renderGraph(chartPoints, isNotSmallerScreen) : null}
        </Box>
    );
}

export default Graph
